import React from 'react';
import { Box } from '@common-fe/common-fe';
import { RoundType } from 'grommet/utils';
import styled from 'styled-components';

import globalTheme from '@/styles/theme';

const StyledOuterBox = styled(Box)<{ $isAppeal?: boolean }>`
  background: ${({ theme, $isAppeal }) => ($isAppeal ? theme.colors.textHighlighter : theme.colors.canvas)};
`;

const OnHoverWrap = styled(Box)<{ isActive?: boolean }>`
  position: relative;
  box-shadow: none;
  outline: 1px solid ${({ isActive, theme }) => (isActive ? theme.colors.iconAccent : theme.colors.border1)};
  border: 1px solid ${({ isActive, theme }) => (isActive ? theme.colors.iconAccent : 'transparent')};

  &:hover {
    cursor: pointer;
    outline-color: ${({ theme }) => theme.colors.iconAccent};
    border-color: ${({ theme }) => theme.colors.iconAccent};
  }
`;

interface Props {
  children: React.ReactNode;
  isActive?: boolean;
  isAppeal?: boolean;
  onClick?: () => void;
  hasBoxShadow?: boolean;
  round?: RoundType;
}

const BorderWrapper: React.FC<Props> = ({
  children, isActive, isAppeal, onClick, hasBoxShadow, round,
}) => (
  <StyledOuterBox
    width={{ min: '40px', max: '40px' }}
    height={{ min: '40px', max: '40px' }}
    round={round}
    $isAppeal={isAppeal}
    style={hasBoxShadow ? { boxShadow: globalTheme.shadows.active['box-shadow'] } : undefined}
  >
    <OnHoverWrap
      margin="xxsmall"
      overflow="hidden"
      round="checkboxRound"
      height="40px"
      justify="center"
      background="canvas"
      isActive={isActive}
      {...(onClick ? { onClick } : {})}
    >
      {children}
    </OnHoverWrap>
  </StyledOuterBox>
);

export default BorderWrapper;
